module.exports = __webpack_public_path__ + "static/media/logo-cancun2.173142b8.png";